import { memo, useState } from 'react';

import { TableCell, TableHead, TableRow } from '@mui/material';

import { BoldText } from '@app/components/common/BoldText';
import { ColumnInterface, GenericObject } from '@app/components/common/Table/DefaultTable/types';

import { ColumnCell } from './ColumnCell';

interface DefaultTableHeaderProps {
  columns: ColumnInterface[];
  orderable?: boolean;
  hasActions?: boolean;
}

export const DefaultTableHeader = memo(({ columns, orderable, hasActions }: DefaultTableHeaderProps) => {
  const [order, setOrder] = useState({});

  const handleChangeOrder = (newOrder: GenericObject) => {
    setOrder(newOrder);
  };

  return (
    <TableHead
      sx={{
        height: 40,
        backgroundColor: '#f7fafc',
      }}>
      <TableRow>
        {orderable && <TableCell align="center" />}

        {columns.map((column: ColumnInterface) => (
          <ColumnCell key={column.key} column={column} order={order} handleChangeOrder={handleChangeOrder} />
        ))}
        {hasActions && (
          <TableCell align="center">
            <BoldText>ACTIONS</BoldText>
          </TableCell>
        )}
      </TableRow>
    </TableHead>
  );
});
